import React from "react";
import "./css/HamburgerMenu.css";

const HamburgerMenu = ({ isOpen, toggleMenu }) => {
  return (
    <button
      className="hamburger-menu"
      onClick={toggleMenu}
      aria-label="Toggle navigation"
    >
      <span className={`hamburger-line ${isOpen ? "open-top" : ""}`}></span>
      <span className={`hamburger-line ${isOpen ? "open-middle" : ""}`}></span>
      <span className={`hamburger-line ${isOpen ? "open-bottom" : ""}`}></span>
    </button>
  );
};

export default HamburgerMenu;
